export const VOLATILE_KEYS = new Set([
  "_key","id","createdAt","updatedAt","created_by","updated_by",
  "version","lastUpdate","last_updated","timestamp",
]);

const isPlainObject = (v) => v != null && typeof v === "object" && !Array.isArray(v);


export function coerceValue(value) {
  if (value === undefined || value === null) return null;
  if (typeof value === "number") return Number.isFinite(value) ? Number(value.toFixed(8)) : null;
  if (typeof value === "boolean") return value;
  if (typeof value === "string") {
    const s = value.trim();
    if (s === "") return null;
    const sl = s.toLowerCase();
    if (sl === "true") return true;
    if (sl === "false") return false;
    const maybeNum = s.replace(",", ".");
    if (/^-?\d+(\.\d+)?$/.test(maybeNum)) {
      const n = Number(maybeNum);
      if (Number.isFinite(n)) return Number(n.toFixed(8));
    }
    return s;
  }
  return value;
}

export function normalizeForSignatureUtilService(value, {
  volatileKeys = VOLATILE_KEYS,
  coerce = coerceValue,
  removeFalse = true,
  removeEmptyString = true,
} = {}) {
  const isRemovable = (v) =>
    v == null
    || (removeFalse && v === false)
    || (removeEmptyString && typeof v === "string" && v.trim() === "")
    || (Array.isArray(v) && v.length === 0)
    || (isPlainObject(v) && Object.keys(v).length === 0);

  const norm = (x) => {
    if (x == null) return null;

    if (Array.isArray(x)) {
      const arr = x.map(norm).filter((y) => !isRemovable(y));
      return arr.length ? arr : null;
    }

    if (!isPlainObject(x)) {
      const v = coerce ? coerce(x) : x;
      return isRemovable(v) ? null : v;
    }

    const obj = Object.fromEntries(
      Object.entries(x)
        .filter(([k]) => !volatileKeys.has(k))
        .map(([k, v]) => [k, norm(v)])
        .filter(([, v]) => !isRemovable(v))
        .sort(([a], [b]) => a.localeCompare(b))
    );

    return Object.keys(obj).length ? obj : null;
  };

  return norm(value);
}

export const normalizeRowsForSignature = (rows, opts) =>
  rows.map((r) => normalizeForSignatureUtilService(r, opts));

export const makeSig = (obj, opts) =>
  JSON.stringify(normalizeRowsForSignature([obj], opts));